import React, { useEffect, useMemo } from 'react';
import { PageLoader } from '../shared/PageLoader';
import AuthApp from './AuthApp';
import { LoaderWrapper } from './elements';
import UnauthApp from './UnauthApp';
import { useAuthContext } from '../../hooks/useAuthContext';

import useGratitudeCheck from 'hooks/useGratitudeCheck';
import useScrollAnchor from 'hooks/useScrollAnchor';

const App = () => {
  const { userData, pending, loaded, authorized, fetchUserData, fetchFeatures } = useAuthContext();
  const gratitudeCheck = useGratitudeCheck();
  useScrollAnchor();
  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    if (userData) {
      gratitudeCheck.fetch();
      fetchFeatures();
    }
  }, [userData]);

  if (pending || !loaded || (userData && !gratitudeCheck.loaded)) {
    return (
      <LoaderWrapper>
        <PageLoader />
      </LoaderWrapper>
    );
  }
  return authorized ? <AuthApp /> : <UnauthApp />;
};

export default App;

// const data =
// const localName = localStorage.getItem('display_name');
// if (window.Sentry && localName) {
// 	window.Sentry.configureScope(function (scope) {
// 		scope.setUser({ last_display_name: localName });
// 	});
// }
